<template>
    <div style="min-height:350px;border-radius:8px" class="card pt-0 mb-3 bg-white px-3 py-3">
        <div class="row">
            <div class="col-6 text-left">
            <h4 class="card-title pt-2 pb-2 mb-0">Absensi Kehadiran</h4>
            </div>
            <div class="col-6 text-right">
                <model-select v-if="icon == 'Y'" style="background-color:rgba(249, 250, 252, 1)" :options="dataFilter" class="form-control" v-model="filter" placeholder="Tipe Pegawai"></model-select>
            </div>
        </div>
        <div class="row no-gutters">
            <div class="col-md-1">
                <hr class="border-primary"/>
            </div>
            <div class="col-md-11">
                <hr/>
            </div>
        </div>
        <div id="chart">
            <apexchart type="bar" v-if="status == true" height="230" :options="chartOptions" :series="series"></apexchart>
        </div>
    </div>
</template>

<script>
import {DataApi} from "../../service/DataApi";
import { ModelSelect } from 'vue-search-select'
export default {
    components: {
        ModelSelect
    },
    data() {
        return {
            status: false,
            icon: '',
            dataLibur: [],
            filter: {
                text: '',
                value: ''
            },
            dataFilter: [],
            series: [
            {
                data: [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
                // data: [32,34,56,77],
                name: 'absensi',
            }
            ],
            chartOptions: {
                chart: {
                    type: 'bar',
                    height: 230,
                    stackType: '100%'
                },
                plotOptions: {
                    bar: {
                        horizontal: false,
                    }
                },
                // colors: this.getColors(),
                colors: ['#008FFB', '#FF4560','#008FFB', '#FF4560'],
                dataLabels: {
                    enabled: true,
                    offsetX: 0,
                    style: {
                        fontSize: '10px',
                        colors: ['#fff']
                    },
                    position: 'bottom'
                },
                xaxis: {
                    categories: [],
                    // categories: [1,2,3,4],
                    title: {
                        text: ''
                    },
                    labels: {
                        style: {
                            colors: []
                        }
                    }
                },
                yaxis: {
                    labels: {
                        formatter: function (val) {
                            return val + "%"
                        }
                    }
                },
                tooltip: {
                    y: {
                        formatter: function (val) {
                        return val + "%"
                        }
                    },
                    x: {
                        formatter: function (val) {
                            return "Tanggal " + val
                        }
                    }
                },
            },
        }
    },
    watch: {
        filter() {
            this.status = false
            this.getData()
        }
    },
    mounted() {
        this.getData()
        this.getDataFilter()
    },
    methods: {
        getDataFilter() {
            this.dataFilter = [
                { value: '', text: 'Semua' },
                { value: '1', text: 'Pegawai' },
                { value: '2', text: 'IT Support' },
            ]
        },
        getData() {
            let payload = {
                tipePegawai: this.filter.value
            }
            DataApi.post("dashboard/dua", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    let temp = response.data
                    let dataList = temp.listPresensi
                    let totalList = parseInt(temp.totalPegawai)
                    this.icon = temp.perusahaan
                    var i = 0
                    for(i=0;i<dataList.length;i++) {
                        let totalPresensi = parseInt(dataList[i])
                        let hasil = Math.floor((totalPresensi/totalList)*100)
                        if(hasil == 0) {
                            hasil = 0.01
                        }
                        this.series[0].data[i] = hasil
                    }
                    this.chartOptions = {
                        chart: {
                            type: 'bar',
                            height: 230,
                            stackType: '100%'
                        },
                        plotOptions: {
                            bar: {
                                horizontal: false,
                            }
                        },
                        // colors: this.getColors(),
                        colors: ['#008FFB', '#FF4560','#008FFB', '#FF4560'],
                        dataLabels: {
                            enabled: true,
                            offsetX: 0,
                            style: {
                                fontSize: '10px',
                                colors: ['#fff']
                            },
                            position: 'bottom'
                        },
                        xaxis: {
                            categories: temp.listTanggal,
                            // categories: [1,2,3,4],
                            title: {
                                text: temp.title
                            },
                            labels: {
                                style: {
                                    colors: temp.listWarna
                                }
                            }
                        },
                        yaxis: {
                            labels: {
                                formatter: function (val) {
                                    return val + "%"
                                }
                            }
                        },
                        tooltip: {
                            y: {
                                formatter: function (val) {
                                return val + "%"
                                }
                            },
                            x: {
                                formatter: function (val) {
                                    return "Tanggal " + val
                                }
                            }
                        },
                    },
                    this.status = true
                } else {
                    this.errorMessage = response.message
                }
                this.$emit('flag', 1)
            })
        },
    },
}
</script>
<style scoped>
.card-title {
    font-size: 18px;
    color: rgba(0, 0, 0, 1);
}
</style>